import { useDeleteTranslation } from 'api/translations';
import { CustomDeleteModal } from 'components/modal';
import { useTranslationStore } from 'store/translationStore';
import useCustomToast from 'utils/use-toast';

function DeleteWorkflowModal({
  isOpen,
  onClose,
}: {
  onClose: () => void;
  isOpen: boolean;
}) {
  const { translation } = useTranslationStore(state => state);
  const deleteTranslation = useDeleteTranslation();
  const toast = useCustomToast();

  const handleSubmit = () => {
    deleteTranslation.mutate(
      {
        translationId: translation.id,
      },
      {
        onSuccess: () => {
          toast.success('translation deleted successfully');
          onClose();
        },
        onError: (error: any) => {
          toast.showError(error);
        },
      },
    );
  };

  return (
    <CustomDeleteModal
      isOpen={isOpen}
      onClose={onClose}
      loading={deleteTranslation.isLoading}
      handleSubmit={handleSubmit}
      heading="Remove Translation"
      text={'Are you sure to remove this translation?'}
    />
  );
}

export default DeleteWorkflowModal;
